module.exports = __webpack_public_path__ + "static/224c217e20449356cb392eb26c5fe206.png";